import React from 'react';
import { Form, Input, Button } from 'antd';

const CompanyInformationForm = ({ triggerNextStep }) => {

  const handleSubmit = (values) => {
    const personalInfo = window._genesys.widgets.webchat.userData
    window._genesys.widgets.webchat.userData = {
      ...personalInfo,
      ...values
    }
    triggerNextStep()
  }

  return (
    <Form 
      onFinish={handleSubmit} 
      layout="vertical" 
      style={{marginTop: "20px", paddingTop:"20px",width:"80%"}}
      initialValues={window._genesys.widgets.webchat.userData}
    >
      <p style={{fontWeight: 'bold',  textAlign: "center"}}> 
        We’d love to provide you a comprehensive plan for your business. Kindly fill-out the following details:
      </p>
      <Form.Item
        name="companyName"
        rules={[{ required: true, message: "Please enter your company's name." }]}
      >
        <Input placeholder="Company Name" />
      </Form.Item>

      <Form.Item
        name="companyAddress"
        rules={[{ required: true, message: "Please enter your company's address." }]}
      >
        <Input placeholder="Company Address"/>
      </Form.Item>

      <Form.Item
        name="companyContactPerson"
        rules={[{ required: true, message: "Please enter your company's contact person." }]}
      >
        <Input placeholder="Company's Contact Person"/>
      </Form.Item>

      <Form.Item
        name="companyContactNumber"
        rules={[{ required: true, message: "Please enter the contact number of your contact person." }]}
      >
        <Input placeholder="Contact Number of your Contact Person"/>
      </Form.Item>

      <Form.Item
        name="companyContactEmailAddress"
        rules={[{ required: true, message: "Please enter the contact email address of your contact person." }]}
      >
        <Input placeholder="Email Address of your Contact Person"/>
      </Form.Item>

      <Form.Item
        name="numberOfEmployeesToEnroll"
        rules={[
          { required: true, message: "Please enter the number of employees to enroll" },
          { validator: (_, value) => (value > 0 && value % 1 === 0) ? Promise.resolve() : Promise.reject('Please enter a positive whole number.'), }
        ]}
      >
        <Input placeholder="Number of Employees to be enrolled"/>
      </Form.Item>

      <Form.Item>
        <Button 
          type="primary" 
          htmlType="submit"
          style = {{
            borderRadius: "0px",
            width:"100%",
            marginTop: "20px",
            height: "50px",
            paddingTop: "0px"
          }}
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CompanyInformationForm;